import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import { toAbsoluteUrl } from "sr/helpers";
import { ReactTimePicker } from "sr/helpers/ui-components/ReactTimePicker";

export const SelectandContinue = (props:any) => {
  const intl = useIntl()
  const [isFocused, setIsFocused] = useState(false);
  const [isFocused1, setIsFocused1] = useState(false);
  const [from, setFrom] = useState<string>()
  const [to, setTo] = useState<string>()
const [jobId, setJobId] = useState<string>()
const [startSelectedTime, setStartSelectTime] = useState('12:00')
const [endSelectedTime, setEndSelectTime] = useState('23:59')
  const toMinutes = (value?: string) => {
    if (!value) return 0;
    const [h = '0', m = '0'] = value.split(':');
    return Number(h) * 60 + Number(m);
  }

  let shouldRender = false
const navigate = useNavigate()
const location = useLocation()
const jobDraft = (location?.state as any)?.jobDraft || props?.jobDraft || props?.jobData
  const param = useParams()
  useEffect(()=>{
const {from, to, id, jobid} = param

setFrom(from)

setTo(to)
setJobId(jobid)
  },[param])
  const hour1 = Number(from?.split(':')[0]==='00' ? 24 : from?.split(':')[0]) 
  const hour2 = Number(to?.split(':')[0]==='00' ? 24 : to?.split(':')[0])
  const scheduleDate = props?.jobData?.schedule_date || jobDraft?.schedule_date
  const isSelectedDateToday = useMemo(() => {
    if (!scheduleDate) return false;
    const today = new Date();
    return new Date(scheduleDate).toDateString() === today.toDateString();
  }, [scheduleDate]);
  const getNowIfToday = () => isSelectedDateToday ? new Date() : null;



  const HandleRender = (e)=> {
        shouldRender = true
  }

  // const handleTime = (e, type, timetype)=> {
  
    
  // if(type==='hour') {
  //         if(timetype==='start'){
     
            
  //         setStartHour(e.target.value)
  //         }
  //         else {
  //           setEndHour(e.target.value)
  //         }
  //         setIsFocused(false)
  //     }
  //     if(type==='minute') {
  //       if(timetype==='start'){
  //       if(!starthour) {
  //         toast.error('First select hour')
  //         return
  //       }
  //       setStartMinute(e.target.value)
  //     }
  //     else {
  //       if(!endHour) {
  //         toast.error('First select hour')
  //         return
  //       }
  //       setEndMinute(e.target.value)
  //     }
  //       setIsFocused1(false)
  //   }
  //   if(shouldRender) {
  //     e.target.blur()
  //   }

  // }
 function getDisabledHours(hour1, hour2) {
  const hours = Array.from({ length: 24 }, (_, i) => i); // [0..23]
  const disabled = [];

  for (let h = 0; h < 24; h++) {
    // If range doesn't wrap (normal case, e.g., 10 → 18)
    if (hour1 <= hour2) {
      if (h < hour1 || h > hour2) disabled.push(h);
    } 
    // If range wraps around midnight (e.g., 22 → 2)
    else {
      if (h > hour2 && h < hour1) disabled.push(h);
    }
  }

  return disabled;
}


  const handleChange = ()=> {
    if(!startSelectedTime || !endSelectedTime) {
      toast.error(intl.formatMessage({id:"INDIVIDUAL.TIME.ERROR.SELECT_BOTH", defaultMessage:"Please select start time and end time."}))
      return
    }
    const now = getNowIfToday();
    if (now) {
      const nowMinutes = now.getHours() * 60 + now.getMinutes();
      if (toMinutes(startSelectedTime) < nowMinutes) {
        toast.error(intl.formatMessage({id:"INDIVIDUAL.TIME.ERROR.START_PAST", defaultMessage:"Selected start time has already passed. Please choose a future time."}));
        setStartSelectTime(`${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`);
        return;
      }
      if (toMinutes(endSelectedTime) < nowMinutes) {
        toast.error(intl.formatMessage({id:"INDIVIDUAL.TIME.ERROR.END_PAST", defaultMessage:"Selected end time has already passed. Please choose a future time."}));
        setEndSelectTime(`${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`);
        return;
      }
      if (toMinutes(endSelectedTime) <= toMinutes(startSelectedTime)) {
        toast.error(intl.formatMessage({id:"INDIVIDUAL.TIME.ERROR.END_AFTER_START", defaultMessage:"End time must be after start time."}));
        setEndSelectTime(startSelectedTime);
        return;
      }
    }
    const rate = (props?.item?.job_types?.length ?  (props?.item?.job_types[0]?.rate || props?.rate) : props?.rate)
    const confirmId = jobId || 'draft'
    props?.setModel(false)
    navigate(`/individual/confirm/${confirmId}`, {state:{
      jobDraft,
      selectedCleaner: props?.item,
      startSelectedTime,
      endSelectedTime,
      rate,
      profileImg: props?.profileImg
    }})
  }

  const disabledHours = ()=>{
    const time = getDisabledHours(hour1, hour2)
    const now = getNowIfToday();
    if (now) {
      for (let h = 0; h < now.getHours(); h++) {
        if (!time.includes(h)) time.push(h);
      }
    }
    return time;
  }
  const disabledMinutes = (selectedHour:number)=>{
    const now = getNowIfToday();
    if (!now) return [];
    if (selectedHour !== now.getHours()) return [];
    return Array.from({ length: now.getMinutes() + 1 }, (_, i) => i);
  }
  useEffect(() => {
    const now = getNowIfToday();
    if (!now) return;
    const nowStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    if (startSelectedTime && toMinutes(startSelectedTime) < toMinutes(nowStr)) {
      setStartSelectTime(nowStr);
    }
    if (endSelectedTime && toMinutes(endSelectedTime) < toMinutes(nowStr)) {
      setEndSelectTime(nowStr);
    }
    if (startSelectedTime && endSelectedTime && toMinutes(endSelectedTime) < toMinutes(startSelectedTime)) {
      setEndSelectTime(startSelectedTime);
    }
  }, [isSelectedDateToday]);
  useEffect(() => {
    const nowStr = `${String(new Date().getHours()).padStart(2, '0')}:${String(new Date().getMinutes()).padStart(2, '0')}`;
    const defaultStart = isSelectedDateToday ? nowStr : (from || '00:00');
    let defaultEnd = isSelectedDateToday ? '23:59' : (to || '23:59');
    if (to) {
      defaultEnd = toMinutes(defaultEnd) > toMinutes(to) ? to : defaultEnd;
    }
    const clampedStart = from ? (toMinutes(defaultStart) < toMinutes(from) ? from : defaultStart) : defaultStart;
    const clampedEnd = to ? (toMinutes(defaultEnd) > toMinutes(to) ? to : defaultEnd) : defaultEnd;
    const finalEnd = toMinutes(clampedEnd) < toMinutes(clampedStart) ? clampedStart : clampedEnd;
    setStartSelectTime(clampedStart);
    setEndSelectTime(finalEnd);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedDateToday, from, to]);

  return (
        <div className="h-[50%] w-full mx-auto">
          <div>
          <div className="flex items-start justify-between p-5 rounded-t">

                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-1 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  
                  >
                    <span onClick={()=> props?.setModel(false)} className="bg-transparent text-black opacity-1 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
          <h1 className="text-2xl font-bold text-center my-4"><FormattedMessage id="INDIVIDUAL.CLEANER.CALENDAR.TITLE" defaultMessage="Choose your task date and start time" /></h1>
    <div className="flex space-x-3 items-center px-8">
      <img className="w-10 h-10 rounded-full" src={props?.profileImg ? props?.profileImg : toAbsoluteUrl('/media/icons/displayProfilePlaceholder.png')}></img>
      <div className="text-sm ">{props?.item?.first_name} {props?.item?.last_name} </div>
    </div>
    <div className="mt-10 ">
          <p className=" text-lg flex justify-center  mb-3">Start Time </p>
          
        <div className="flex justify-center items-center text-lg space-x-1">
                 {(disabledHours)   && <ReactTimePicker InputDivClass={'mt-2'} disabledHours={disabledHours} disabledMinutes={disabledMinutes} value={startSelectedTime} onChange={(value)=> setStartSelectTime(value)} ></ReactTimePicker>}


        </div>
        </div>
        <div className="mt-10">
        <p className=" text-lg flex justify-center  mb-3">End Time </p>
       <div className="flex justify-center items-center text-lg space-x-1">
        {(disabledHours)   && <ReactTimePicker InputDivClass={'mt-2'} disabledHours={disabledHours} disabledMinutes={disabledMinutes} value={endSelectedTime} onChange={(value)=> setEndSelectTime(value)} ></ReactTimePicker>}


        </div>
        </div>
        </div>
        <div onClick={handleChange} className="my-10 text-center font-bold bg-[#ff39b3] font-bold px-5 py-2 flex justify-center w-20 mx-auto  text-white cursor-pointer hover:bg-navy rounded-lg">
          <FormattedMessage id="INDIVIDUAL.CLEANERS.CONTINUE.BUTTON" defaultMessage="Continue" />
        </div>
        </div>
  )
  
  ;};
